import { render, staticRenderFns } from "./MortgageGuidanceTypeButton.vue?vue&type=template&id=28980001&scoped=true"
import script from "./MortgageGuidanceTypeButton.vue?vue&type=script&lang=js"
export * from "./MortgageGuidanceTypeButton.vue?vue&type=script&lang=js"
import style0 from "./MortgageGuidanceTypeButton.vue?vue&type=style&index=0&id=28980001&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28980001",
  null
  
)

export default component.exports